module.exports = __webpack_public_path__ + "static/img/z04.709de358.png";